/**
 * Profilcache der Auth-Oberfläche: bei „Angemeldet bleiben“ localStorage, sonst sessionStorage.
 * Der Session-Token selbst liegt im HttpOnly-Cookie (mQmarketing/mQguard) bzw. zusätzlich
 * im jeweiligen Storage (m1member, solange Stufe 4/HttpOnly aussteht).
 */
function sessionStore(): Storage | null {
  try {
    return typeof sessionStorage === "undefined" ? null : sessionStorage;
  } catch {
    return null;
  }
}

function localStore(): Storage | null {
  try {
    return typeof localStorage === "undefined" ? null : localStorage;
  } catch {
    return null;
  }
}

export function readPersistedValue(key: string): string | null {
  const fromSession = sessionStore()?.getItem(key);
  if (fromSession) return fromSession;
  return localStore()?.getItem(key) ?? null;
}

export function writePersistedValue(key: string, value: string | null, persist?: boolean): void {
  const session = sessionStore();
  const local = localStore();
  if (value == null || value === "") {
    session?.removeItem(key);
    local?.removeItem(key);
    return;
  }

  if (persist === false) {
    session?.setItem(key, value);
    local?.removeItem(key);
    return;
  }

  if (persist === true) {
    local?.setItem(key, value);
    session?.removeItem(key);
    return;
  }

  if (session?.getItem(key)) {
    session.setItem(key, value);
    return;
  }

  local?.setItem(key, value);
}

export function isPersistedInLocalStorage(key: string): boolean {
  return !!localStore()?.getItem(key);
}
